<template>
  <div>
    <StructureTable
      :items="items"
      :headers="headers"
      :totalItems="totalTagGroups"
      :loading="loading"
      :title="$t('organization_structure.tags_group_other')"
      @getItems="$emit('getTagGroups', $event)"
      @edit="handleEdit"
    />

    <EditTagsGroupDialog
      :organizationId="organizationId"
      :tagsGroup="selectedTagsGroup"
      :visible="showEditDialog"
      :loading="loading || saving"
      @close="handleClose"
      @save="saveTagsGroup"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import StructureTable from '../../Shared/StructureTable.vue'
import EditTagsGroupDialog from './EditTagsGroupDialog.vue'

import api from '@/api'
import mixin from '@/mixins/mixin.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TagGroupsTab',

  mixins: [mixin],

  components: {
    StructureTable,
    EditTagsGroupDialog,
  },

  props: {
    organizationId: String,
    tagGroups: { type: Array, required: true },
    loading: Boolean,
    totalTagGroups: { Number },
  },

  data() {
    return {
      saving: false,
      selectedTagsGroup: null,
      showEditDialog: false,
      headers: [
        {
          text: _.capitalize(this.$t('common.tags_group_name')),
          align: 'start',
          sortable: true,
          value: 'name',
          show: true,
          width: '100px',
        },
        {
          text: _.capitalize(this.$t('common.tag_other')),
          sortable: false,
          value: 'tags',
          align: 'start',
          show: true,
          width: '200px',
        },

        {
          text: _.capitalize(this.$t('common.action_other')),
          sortable: false,
          value: 'actions',
          show: true,
          align: 'center',
          width: '80px',
        },
      ],
    }
  },

  computed: {
    ...mapGetters(['account']),

    items() {
      return this.tagGroups.map(group => {
        return {
          ...group,
          name: group.name,
          id: group._id,
        }
      })
    },
  },

  methods: {
    ...mapActions(['getOrganizationStructure']),

    handleClose() {
      this.selectedTagsGroup = null
      this.showEditDialog = false
    },

    handleEdit(tagsGroup) {
      this.selectedTagsGroup = tagsGroup
      this.showEditDialog = true
    },

    async saveTagsGroup(tagsGroup) {
      this.saving = true
      try {
        if (!_.isEqual(tagsGroup.tags, this.selectedTagsGroup.tags))
          await api.tagGroups.addTags(this.organizationId, tagsGroup.id, {
            tags: tagsGroup.tags,
          })

        await api.tagGroups.update(this.organizationId, tagsGroup.id, {
          ...tagsGroup,
          name: tagsGroup.name.trim(),
        })
        if (this.account?.organization?._id === this.organizationId) {
          await this.getOrganizationStructure({
            organizationId: this.organizationId,
          })
        }
        this.selectedTagsGroup = null
        this.showEditDialog = false
        this.$emit('getTagGroups')
        this.$emit('getTags')
        this.$emit('cleanSearchTerm')
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
